import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Typography, Row, Col, Input, Button, Space, Card, Tag, Empty, Spin, Alert } from "antd";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";

import AppHeader from "../../components/Header";
import AppFooter from "../../components/Footer";
import "./index.css";

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

export default function Home({ posts, loading, error, loggedInUser, onLogout }) {
  const nav = useNavigate();
  const [q, setQ] = useState("");

  const filtered = useMemo(() => {
    const kw = (q || "").trim().toLowerCase();
    if (!kw) return posts || [];
    return (posts || []).filter((p) => {
      const hay = `${p.title} ${p.summary} ${p.content} ${(p.tags || []).join(" ")}`.toLowerCase();
      return hay.includes(kw);
    });
  }, [q, posts]);

  return (
    <Layout className="dmc dmc-layout page-shell home-layout">
      <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />

      <Content className="page-content home-content">
        <div className="home-container">
          <div className="home-hero">
            <div>
              <Title level={3} style={{ marginBottom: 6 }}>首页</Title>
            </div>

            <Space className="home-hero-actions" wrap>
              <Input
                allowClear
                value={q}
                onChange={(e) => setQ(e.target.value)}
                prefix={<SearchOutlined />}
                placeholder="搜索文章 / 标签…"
                style={{ width: 320 }}
              />
              <Button type="primary" icon={<PlusOutlined />} onClick={() => nav("/write")}>
                写文章
              </Button>
            </Space>
          </div>

          {loading ? (
            <div className="state-block"><Spin /></div>
          ) : error ? (
            <div className="state-block">
              <Alert type="error" showIcon message="加载失败" description={String(error)} />
            </div>
          ) : filtered.length === 0 ? (
            <div className="state-block">
              <Empty description="暂无文章" />
              <Button type="primary" onClick={() => nav("/write")}>去写第一篇</Button>
            </div>
          ) : (
            <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
              {filtered.map((post) => (
                <Col key={post.id} xs={24} md={12} xl={8}>
                  <Card hoverable className="post-card" onClick={() => nav(`/post/${post.id}`)}>
                    <Title level={5} style={{ marginTop: 0 }}>{post.title}</Title>
                    <Paragraph type="secondary" ellipsis={{ rows: 2 }}>{post.summary}</Paragraph>
                    <Text type="secondary">{post.date}</Text>

                    <div style={{ marginTop: 10 }}>
                      <Space size={6} wrap>
                        {(post.tags || []).slice(0, 6).map((t) => <Tag key={t}>#{t}</Tag>)}
                      </Space>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </div>
      </Content>

      <AppFooter />
    </Layout>
  );
}
